import { EGateway } from '@domain/enums/common/EGateway';

export const YAMPI_GATEWAYS = [
  EGateway.MERCADO_PAGO,
  EGateway.PAG_SEGURO,
  EGateway.PAGARME,
  EGateway.UPNID,
  EGateway.HUB_SALE,
];
